import {
	getVariantPrice,
	moneyToNumber,
} from "@babybjorn/utils/commercetools/money";
import type { TCountryCode } from "countries-list";
import { getVariantStringAttribute } from "../../../templates/product-page/product-page.helper";
import type { EcommerceItem } from "../use-gtm-variables";

interface ProductDetailEvent {
	ecommerce: {
		detail: {
			products: EcommerceItem[];
		};
	};
}

export const getData = (
	variant: Queries.ProductVariantFragment,
	product: Queries.CommerceToolsProductFragment,
	currency: string,
	country?: TCountryCode,
): ProductDetailEvent => {
	const price = getVariantPrice(variant, currency, country);

	return {
		ecommerce: {
			detail: {
				products: [
					{
						name: product.name || "",
						id: variant.sku || "",
						price: moneyToNumber(price).toString(),
						brand: "Babybjorn",
						category:
							getVariantStringAttribute(variant, "gtm-category-name")?.value ||
							undefined,
						variant: variant.key || "",
					},
				],
			},
		},
	};
};
